<div class="layout-wrapper" [ngClass]="containerClass" [attr.data-p-theme]="theme">
    <app-config (onDarkModeSwitch)="toggleDarkMode()"></app-config>
    <div class="layout-topbar">
        <app-navigation [active]="menuActive"></app-navigation>
        <p-breadcrumb [model]="crumbs$ | async" [home]="home"></p-breadcrumb>
    </div>
    <div class="layout-content">
        <router-outlet></router-outlet>
        <app-footer></app-footer>
    </div>
</div>